/**
 * Packages & Services builder — composition draft model. Extracted
 * verbatim from the former AgencyServicesPage monolith (Task 150-A).
 * No behavior change.
 */

import type {
  PackageServiceDeliverable,
  PackageServiceLine,
  PricingModel,
  ServiceCadence,
  SystemCapabilityKey,
} from '../../api/types';

export interface DraftServiceLine {
  readonly service_id: string;
  readonly service_name: string;
  readonly system_capability_key: SystemCapabilityKey;
  readonly capability_keys: ReadonlyArray<SystemCapabilityKey>;
  included: boolean;
  quantity: number | null;
  notes: string | null;
  deliverables: ReadonlyArray<PackageServiceDeliverable>;
  pricing_model: PricingModel | null;
  retainer_amount: number | null;
  retainer_currency: string;
  spend_percentage: number | null;
  cadence: ServiceCadence | null;
  sort_order: number;
  terms_notes: string | null;
}

export function packageServiceToDraft(s: PackageServiceLine): DraftServiceLine {
  return {
    service_id: s.service_id,
    service_name: s.service_name,
    system_capability_key: s.system_capability_key,
    capability_keys: s.capability_keys,
    included: s.included,
    quantity: typeof s.quantity === 'number' ? s.quantity : s.quantity ? Number(s.quantity) : null,
    notes: s.notes,
    deliverables: s.deliverables,
    pricing_model: s.pricing_model,
    retainer_amount:
      typeof s.retainer_amount === 'number'
        ? s.retainer_amount
        : s.retainer_amount
          ? Number(s.retainer_amount)
          : null,
    retainer_currency: s.retainer_currency,
    spend_percentage:
      typeof s.spend_percentage === 'number'
        ? s.spend_percentage
        : s.spend_percentage
          ? Number(s.spend_percentage)
          : null,
    cadence: s.cadence,
    sort_order: s.sort_order,
    terms_notes: s.terms_notes,
  };
}
